import { atom } from 'jotai';

import sidePanels from '$components/SidePanel/sidePanels';

export type PanelAtom = {
    panel: null | keyof typeof sidePanels;
    payload?: Record<string, unknown>;
};
export const panelAtom = atom<PanelAtom | null>({ panel: null });
